import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Reminders from "@/pages/Reminders";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Notes from "@/pages/Notes";
import Completed from "@/pages/Completed";
import SalesLayout from "@/pages/sales/SalesLayout";
import SalesHome from "@/pages/sales/SalesHome";
import SalesCompanies from "@/pages/sales/Companies";
import CompanyProfile from "@/pages/sales/CompanyProfile";
import Pipeline from "@/pages/sales/Pipeline";
import SalesFollowups from "@/pages/sales/Followups";
import ImportWizard from "@/pages/sales/ImportWizard";
import SalesSettings from "@/pages/sales/SalesSettings";
import Wallboard from "@/pages/Wallboard";
import Settings from "@/pages/Settings";
import { SettingsProvider } from "@/context/SettingsContext";

function Splash() {
  return (
    <div className="flex min-h-screen items-center justify-center" data-testid="app-loading">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-white/10 border-t-indigo-400" />
    </div>
  );
}

function Protected() {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "screen") return <Navigate to="/wallboard" replace />;
  return (
    <AppProvider>
      <Layout />
    </AppProvider>
  );
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  if (!user) return <Login />;
  return <Navigate to={user.role === "screen" ? "/wallboard" : "/"} replace />;
}

function WallboardRoute() {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  return user ? <Wallboard /> : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/wallboard" element={<WallboardRoute />} />
          <Route path="/" element={<Protected />}>
            <Route index element={<Dashboard />} />
            <Route path="reminders" element={<Reminders />} />
            <Route path="completed" element={<Completed />} />
            <Route path="sales" element={<SalesLayout />}>
              <Route index element={<SalesHome />} />
              <Route path="companies" element={<SalesCompanies />} />
              <Route path="companies/:id" element={<CompanyProfile />} />
              <Route path="pipeline" element={<Pipeline />} />
              <Route path="followups" element={<SalesFollowups />} />
              <Route path="import" element={<ImportWizard />} />
              <Route path="settings" element={<SalesSettings />} />
            </Route>
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:id" element={<ProjectDetail />} />
            <Route path="notes" element={<Notes kind="note" />} />
            <Route path="thoughts" element={<Notes kind="thought" />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </SettingsProvider>
      <Toaster theme="dark" position="bottom-right" richColors closeButton />
    </AuthProvider>
  );
}
